import {
  Box,
  CtaButton,
  Grid,
  IBasicUserType,
  RoundedHelp,
} from '@zappyrent/hundop';
import { rem } from 'polished';
import styled, { css } from 'styled-components';

export const StyledMain = styled.main`
  height: 100vh;
`;

export const StyledGrid = styled(Grid)`
  height: 100%;
  flex-direction: column;
  flex-wrap: nowrap;

  @media (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding: ${rem('160px')} 0 ${rem('40px')} 0;
  }
`;

export const StyledHeader = styled.header`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    position: absolute;
    transform: translateY(${rem('-106px')});
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    width: 100%;
    padding: ${rem('20px')} 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${rem('32px')};
  }
`;

export const StyledIconWrapperButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${rem('24px')};
  height: ${rem('24px')};
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  appearance: none;

  &:not(:first-child) {
    margin-left: ${rem('16px')};
  }
`;

export const StyledRoundedHelp = styled(RoundedHelp)<IBasicUserType>`
  width: ${rem('24px')};
  height: auto;
  margin-left: auto;

  path {
    fill: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

export const StyledBoxesContainer = styled.section`
  display: flex;
  justify-content: space-between;
  gap: ${rem('80px')};
  width: 100%;
  height: 100%;
`;

export const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`;

//common styles to be shared over all components of the page
export const StyledH2 = styled.h2`
  font-size: ${rem('24px')};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.cross.black};
  margin-top: 0;
  line-height: 1.3;
`;

export const StyledH3 = styled.h3<{ tenant: boolean; completed?: boolean }>`
  font-size: ${rem('20px')};
  font-weight: 600;
  color: ${({ theme, tenant }) =>
    tenant ? theme.colors.tenant.main : theme.colors.cross.grayson};
  margin-top: 0;
  position: relative;
  display: inline-block;
  padding-right: ${rem('12px')};

  &::after {
    ${({ completed, theme }) =>
      completed &&
      css`
        content: '';
        display: block;
        width: ${rem('18px')};
        height: ${rem('10px')};
        border-radius: ${rem('2px')};
        border: ${rem('2px')} solid transparent;
        border-bottom-color: ${theme.colors.cross.greenMint};
        border-left-color: ${theme.colors.cross.greenMint};
        position: absolute;
        top: ${rem('1px')};
        left: 100%;
        transform: rotate(-45deg);
      `}
  }
`;

export const StyledText = styled.p<{ black?: boolean }>`
  font-size: ${rem('16px')};
  font-weight: 400;
  margin: 0;
  color: ${({ theme, black }) =>
    black ? theme.colors.cross.black : theme.colors.cross.grayson};
`;

export const StyledList = styled.ul`
  font-size: ${rem('16px')};
  font-weight: 400;
  padding-left: 0;
  margin: ${rem('24px')} 0 0 0;
  color: ${({ theme }) => theme.colors.cross.black};
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${rem('18px')};
`;

export const StyledListItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${rem('5px')};
`;

export const StyledNeedHelp = styled.div`
  display: flex;
  gap: ${rem('16px')};
  align-items: center;

  & a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.tenant.main};
    font-weight: 700;
    font-size: ${rem('14px')};
  }
`;

export const StyledButton = styled(CtaButton).attrs({
  tag: 'button',
  user: 'tenant',
})`
  width: 100%;
  text-transform: uppercase;
  margin: 0;
  margin-top: auto;

  &:hover {
    color: ${({ theme, variant }) =>
      variant === 'secondary' && theme.colors.tenant.mainAlternate};
  }
`;

export const StyledStickyBox = styled(Box)`
  position: sticky;
  bottom: 0;
  padding: ${rem('16px')} 0;
  background-color: ${({ theme }) => theme.colors.main};
  margin-top: ${rem('64px')};

  & > * {
    width: 100%;
  }
`;

export const StyledNarrowWrapper = styled.section`
  width: 80%;
  height: 100%;
  max-width: ${rem('800px')};
  margin: 0 auto;
  text-align: center;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    width: 100%;
  }
`;
